import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="about-container">
				<div className="about-main">
					<div className="about-left-side">
						<div className="title about-title">
							{INFO.about.title}
						</div>

						<div className="subtitle about-subtitle">
							{INFO.about.description.map((text, index) => (
								<p key={index}>{text}</p>
							))}
						</div>
					</div>

					<div className="about-right-side">
						<div className="about-image-container">
							<div className="about-image-wrapper">
								<img
									src="about.jpg"
									alt="about"
									className="about-image"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
